import React from "react";
import "./ReachOut.scss";
import { Container } from "@mui/material";
import PuzzleCart from "./PuzzleCart";

const ReachOut = ({ title }) => {
  const puzzleCarts = [
    {
      details: {
        toll_free: "800.645.9639",
        emergency: "613.267.5206",
      },
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none">
          <g clipPath="url(#clip0_28_1357)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.8036 2.1236C13.8036 1.78261 13.6682 1.45559 13.4271 1.21447C13.1859 0.973349 12.8589 0.837891 12.5179 0.837891C9.22167 0.837891 6.06041 2.14733 3.7296 4.47813C1.39879 6.80894 0.0893555 9.9702 0.0893555 13.2665C0.0893555 13.6075 0.224814 13.9345 0.465932 14.1756C0.707051 14.4167 1.03408 14.5522 1.37507 14.5522C1.71606 14.5522 2.04309 14.4167 2.28421 14.1756C2.52533 13.9345 2.66078 13.6075 2.66078 13.2665C2.66078 10.6522 3.6993 8.14498 5.54787 6.29641C7.39645 4.44784 9.90365 3.40932 12.5179 3.40932C12.6868 3.40932 12.854 3.37606 13.0099 3.31145C13.1659 3.24684 13.3077 3.15213 13.4271 3.03274C13.5465 2.91335 13.6412 2.77162 13.7058 2.61563C13.7704 2.45964 13.8036 2.29245 13.8036 2.1236ZM11.9625 23.7236C11.0738 24.2958 10.016 24.5467 8.96503 24.4344C7.91403 24.3221 6.93311 23.8535 6.18536 23.1065L5.53393 22.455C5.24499 22.163 5.08293 21.7687 5.08293 21.3579C5.08293 20.9471 5.24499 20.5528 5.53393 20.2607L8.27678 17.535C8.56593 17.2472 8.95734 17.0855 9.36536 17.0855C9.77338 17.0855 10.1648 17.2472 10.4539 17.535C10.746 17.824 11.1402 17.986 11.5511 17.986C11.9619 17.986 12.3562 17.824 12.6482 17.535L17.0196 13.1636C17.3086 12.8715 17.4706 12.4773 17.4706 12.0665C17.4706 11.6556 17.3086 11.2614 17.0196 10.9693C16.7318 10.6802 16.5701 10.2888 16.5701 9.88075C16.5701 9.47273 16.7318 9.08132 17.0196 8.79218L19.6596 6.04932C19.9517 5.76038 20.3459 5.59832 20.7568 5.59832C21.1676 5.59832 21.5619 5.76038 21.8539 6.04932L22.5054 6.70075C23.2658 7.43795 23.7504 8.41366 23.8783 9.46504C24.0062 10.5164 23.7697 11.5799 23.2082 12.4779C20.219 16.9158 16.4004 20.7344 11.9625 23.7236ZM13.0562 5.79732C13.3972 5.79732 13.7242 5.93278 13.9654 6.1739C14.2065 6.41501 14.3419 6.74204 14.3419 7.08303C14.3419 7.42403 14.2065 7.75105 13.9654 7.99217C13.7242 8.23329 13.3972 8.36875 13.0562 8.36875C11.5786 8.36875 10.1615 8.95574 9.11662 10.0006C8.07177 11.0454 7.48478 12.4625 7.48478 13.9402C7.48478 14.2812 7.34933 14.6082 7.10821 14.8493C6.86709 15.0904 6.54006 15.2259 6.19907 15.2259C5.85808 15.2259 5.53105 15.0904 5.28993 14.8493C5.04881 14.6082 4.91336 14.2812 4.91336 13.9402C4.91336 11.7806 5.77126 9.70939 7.29834 8.18231C8.82543 6.65522 10.8966 5.79732 13.0562 5.79732Z"
              fill="#008FD5"
            />
          </g>
          <defs>
            <clipPath id="clip0_28_1357">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0 0.649414)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      details: {
        email: "info@valleywatertreatment.ca",
      },
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 5.36391C0 4.68192 0.270918 4.02787 0.753154 3.54563C1.23539 3.0634 1.88944 2.79248 2.57143 2.79248H21.4286C22.1106 2.79248 22.7646 3.0634 23.2468 3.54563C23.7291 4.02787 24 4.68192 24 5.36391V5.95019L12.6566 13.5136C12.4586 13.6328 12.2311 13.694 12 13.6902C11.7689 13.694 11.5414 13.6328 11.3434 13.5136L0 5.95019V5.36391ZM0 8.52505V19.9353C0 20.6173 0.270918 21.2714 0.753154 21.7536C1.23539 22.2358 1.88944 22.5068 2.57143 22.5068H21.4286C22.1106 22.5068 22.7646 22.2358 23.2468 21.7536C23.7291 21.2714 24 20.6173 24 19.9353V8.52505L13.8394 15.2999L13.8309 15.3068C13.2839 15.6546 12.6482 15.8373 12 15.8331C11.3571 15.8331 10.7091 15.6582 10.1691 15.3068L10.1606 15.2999L0 8.52505Z"
            fill="#008FD5"
          />
        </svg>
      ),
    },
    {
      details: {
        address: "15749 Highway 7 Perth, Ontario K7H 0J2",
      },
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none">
          <g clipPath="url(#clip0_28_1384)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.0002 0.649414C16.4951 0.649414 20.2391 4.39341 20.2391 8.88656C20.2391 10.354 19.7351 11.8008 19.0305 13.1106C18.3225 14.4271 17.3865 15.6546 16.4574 16.7003C15.6473 17.61 14.7762 18.4634 13.8499 19.2546C13.5475 19.5138 13.2352 19.7614 12.9139 19.9968C12.8056 20.0756 12.694 20.15 12.5796 20.2197C12.4847 20.2761 12.3849 20.3237 12.2814 20.362C12.0521 20.436 11.8029 20.4176 11.5871 20.3106C11.5295 20.2833 11.4734 20.2529 11.4191 20.2197C11.304 20.1483 11.1919 20.0722 11.0831 19.9917C10.7623 19.7551 10.4506 19.5063 10.1488 19.246C9.22361 18.4506 8.35307 17.5938 7.54308 16.6814C6.61394 15.6323 5.67794 14.4014 4.97165 13.09C4.26708 11.7837 3.76136 10.342 3.76136 8.88656C3.76136 4.39341 7.50536 0.649414 12.0002 0.649414ZM12.0002 11.3466C11.6772 11.3466 11.3573 11.2829 11.0588 11.1593C10.7604 11.0357 10.4892 10.8545 10.2607 10.626C10.0323 10.3976 9.8511 10.1264 9.72748 9.82796C9.60385 9.5295 9.54022 9.20961 9.54022 8.88656C9.54022 8.5635 9.60385 8.24362 9.72748 7.94516C9.8511 7.64669 10.0323 7.37551 10.2607 7.14707C10.4892 6.91864 10.7604 6.73744 11.0588 6.61381C11.3573 6.49019 11.6772 6.42656 12.0002 6.42656C12.6527 6.42656 13.2784 6.68573 13.7397 7.14707C14.201 7.60841 14.4602 8.23412 14.4602 8.88656C14.4602 9.53899 14.201 10.1647 13.7397 10.626C13.2784 11.0874 12.6527 11.3466 12.0002 11.3466ZM17.3145 18.0597C17.6299 17.7048 17.9454 17.3328 18.2574 16.9454H20.5597C20.9025 16.9454 21.2111 17.1511 21.3482 17.4648L23.9145 23.4563C23.9704 23.5867 23.9931 23.729 23.9804 23.8703C23.9678 24.0117 23.9203 24.1477 23.8421 24.2661C23.7639 24.3846 23.6576 24.4817 23.5326 24.5489C23.4076 24.6161 23.2678 24.6513 23.1259 24.6511H0.874507C0.732594 24.6513 0.59287 24.6161 0.467875 24.5489C0.34288 24.4817 0.236525 24.3846 0.158356 24.2661C0.0801863 24.1477 0.0326484 24.0117 0.0200085 23.8703C0.00736851 23.729 0.030022 23.5867 0.0859358 23.4563L2.65394 17.4648C2.72007 17.3106 2.83006 17.1791 2.97024 17.0867C3.11043 16.9944 3.27464 16.9453 3.44251 16.9454H5.76536C6.06879 17.3226 6.37736 17.6877 6.68594 18.0357C7.82079 19.3146 8.96593 20.3946 9.85736 21.1574C10.3031 21.5397 10.6922 21.8466 10.9905 22.0626C11.1379 22.1706 11.2734 22.2614 11.3882 22.3317C11.488 22.3989 11.5972 22.4509 11.7122 22.486C11.9463 22.5629 12.2014 22.5445 12.4219 22.4346C12.4905 22.4037 12.5539 22.366 12.6105 22.3334C12.7461 22.2504 12.8783 22.1617 13.0065 22.0677C13.3048 21.8517 13.6922 21.5466 14.1396 21.1677C15.0311 20.41 16.1796 19.3351 17.3128 18.0597H17.3145Z"
              fill="#008FD5"
            />
          </g>
          <defs>
            <clipPath id="clip0_28_1384">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0 0.649414)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      details: {
        office_hours:
          "Monday to Friday: 8:00 am-4:30 pm Saturday and Sunday: Closed",
        extra: "After-hours emergency service",
      },
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none">
          <g clipPath="url(#clip0_28_1394)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 24.6494C15.1826 24.6494 18.2348 23.3851 20.4853 21.1347C22.7357 18.8843 24 15.832 24 12.6494C24 9.46682 22.7357 6.41457 20.4853 4.16413C18.2348 1.9137 15.1826 0.649414 12 0.649414C8.8174 0.649414 5.76515 1.9137 3.51472 4.16413C1.26428 6.41457 0 9.46682 0 12.6494C0 15.832 1.26428 18.8843 3.51472 21.1347C5.76515 23.3851 8.8174 24.6494 12 24.6494ZM13.0714 8.3637C13.0714 8.223 13.0437 8.08367 12.9899 7.95368C12.936 7.82369 12.8571 7.70558 12.7576 7.60609C12.6581 7.50659 12.54 7.42767 12.41 7.37383C12.28 7.31998 12.1407 7.29227 12 7.29227C11.8593 7.29227 11.72 7.31998 11.59 7.37383C11.46 7.42767 11.3419 7.50659 11.2424 7.60609C11.1429 7.70558 11.064 7.82369 11.0101 7.95368C10.9563 8.08367 10.9286 8.223 10.9286 8.3637V12.6494C10.9286 12.8997 11.016 13.1431 11.1771 13.3351L15.4629 18.478C15.5517 18.5899 15.6619 18.6829 15.7872 18.7516C15.9125 18.8203 16.0503 18.8632 16.1924 18.8778C16.3345 18.8925 16.4781 18.8785 16.6147 18.8368C16.7514 18.7952 16.8783 18.7266 16.9881 18.6351C17.0978 18.5437 17.1882 18.4312 17.2538 18.3043C17.3195 18.1774 17.3591 18.0386 17.3703 17.8962C17.3815 17.7538 17.3641 17.6106 17.3192 17.4749C17.2743 17.3393 17.2026 17.2141 17.1086 17.1066L13.0714 12.262V8.3637Z"
              fill="#008FD5"
            />
          </g>
          <defs>
            <clipPath id="clip0_28_1394">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0 0.649414)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
  ];

  return (
    <div className="reach-out-wrapper">
      <Container>
        <div className="reach-out-wrapper-inside">
          <div className="top-part">
            <p>Contact</p>
            <h1>{title ? title : "Reach Out"}</h1>
          </div>
          <div className="carts-wrapper">
            {puzzleCarts.map((puzzleCart, index) => (
              <PuzzleCart key={index} data={puzzleCart} />
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ReachOut;
